import React from "react";
import { Trans } from "react-i18next";
import {
  SFAdministrationIcon,
  SFTabsLayout,
  SFNavigateWithParams,
} from "@sf-core";
import { Claims } from "./claims";
import { Navigate } from "react-router-dom";
import { PATHS } from "./paths";

// Tenants
import TenantsGrid from "../screens/tenants";
import EditUserTenant from "../screens/users/editUserTenant";
import AddUserTenant from "../screens/users/addUserTenant";
import TenantForm from "../screens/tenants/tenantForm";
import SyncTenantSkills from "../screens/tenants/syncSkills";

// Users
import UsersGrid from "../screens/users";
import NewUser from "../screens/users/newUser";
import UserProfile from "../screens/users/userProfile";

// Execution Flows
import ExecutionFlowsGrid from "../screens/executionFlows";
import AddExecutionFlow from "../screens/executionFlows/addExecutionFlow";

const ROUTES = [
  {
    path: PATHS.DEFAULT_URL, // "/"
    component: <Navigate to={PATHS.ADMIN} replace={true} />,
  },
  {
    // This is when the user clicks on the breadcrumb to go to the admin tenant page. Also for the default to redirect here
    path: PATHS.ADMIN,
    component: <Navigate to={PATHS.ADMIN_TENANTS_LANDING} replace={true} />,
  },
  {
    path: PATHS.ADMIN_USERS_USER,
    component: <SFNavigateWithParams to={PATHS.ADMIN_USERS_USER_PROFILE} replace={true} />,
    permissions: [Claims.AdminUsersEdit],
  },

  {
    label: <Trans i18nKey="adminRoutes.administration" />,
    path: PATHS.ADMIN,
    showInSideMenu: true,
    icon: <SFAdministrationIcon />,
    permissions: [
      Claims.AdminUsersView,
      Claims.AdminUsersAdd,
      Claims.AdminUsersEdit,
      Claims.AdminTenantsView,
      Claims.TenantEmployeesView,
    ],
    component: (
      <SFTabsLayout
        tabs={[
          {
            path: PATHS.ADMIN_TENANTS_LANDING,
            label: <Trans i18nKey="adminRoutes.navTitle.tenantSummary" />,
          },
          {
            path: PATHS.ADMIN_USERS,
            label: <Trans i18nKey="adminRoutes.navTitle.users" />,
          },
          {
            path: PATHS.ADMIN_EXECUTION_FLOW_LANDING,
            label: <Trans i18nKey="adminRoutes.navTitle.settings" />,
          },
        ]}
        excludeTabsFromPaths={[
          `${PATHS.ADMIN_TENANTS_LANDING}/`,
          `${PATHS.ADMIN_USERS}/`,
          `${PATHS.ADMIN_EXECUTION_FLOW_LANDING}/`,
        ]}
      />
    ),
    children: [
      //#region Tenants
      {
        path: PATHS.ADMIN_TENANTS_LANDING,
        permissions: [Claims.AdminTenantsView],
        component: <TenantsGrid />,
        titleSuffix: "adminRoutes.tenants",
      },
      {
        path: PATHS.ADMIN_TENANTS_ADD_TENANT,
        label: <Trans i18nKey="adminRoutes.addTenant" />,
        component: <TenantForm />,
        permissions: [Claims.AdminTenantsEdit],
        titleSuffix: "adminRoutes.titles.addTenant",
        editing: true,
      },
      {   
        path: PATHS.ADMIN_TENANTS_TENANT_DETAILS,
        label: <Trans i18nKey="adminRoutes.editTenant" />,
        permissions: [Claims.AdminTenantsEdit],
        titleSuffix: "adminRoutes.titles.editTenant",
        component: <TenantForm />,
        editing: true,
      },
      {
        path: PATHS.ADMIN_TENANTS_ID_SYNC_SKILLS,
        label: <Trans i18nKey="adminRoutes.tenantSyncSkills" />,
        component: <SyncTenantSkills />,
        permissions: [Claims.AdminTenantsSyncSkills],
      },
      {
        path: PATHS.ADMIN_USERS_EDIT_TENANT_OF_USER,
        component: <EditUserTenant />,
        permissions: [Claims.AdminUsersEdit],
        titleSuffix: "adminRoutes.titles.editUserTenant",
        editing: true,
      },
      //#endregion Tenants
      //#region Users
      {
        path: PATHS.ADMIN_USERS,
        permissions: [Claims.AdminUsersView],
        component: <UsersGrid />,
        titleSuffix: "adminRoutes.titles.users",
      },
      {
        path: PATHS.ADMIN_USERS_ADD_USER,
        label: <Trans i18nKey="adminRoutes.newUser" />,
        component: <NewUser />,
        editing: true,
        permissions: [Claims.AdminUsersAdd],
        titleSuffix: "adminRoutes.titles.newUser",
      },
      {
        path: PATHS.ADMIN_USERS_USER_PROFILE,
        titleSuffix: "adminRoutes.titles.userProfile",
        label: <Trans i18nKey="adminRoutes.userProfile" />,
        permissions: [Claims.AdminUsersEdit],
        component: <UserProfile />,
      },
      {
        path: PATHS.ADMIN_USERS_ADD_TENANT_TO_USER,
        label: <Trans i18nKey="tenantsScreen.addTenantToUser" />,
        component: <AddUserTenant />,
        permissions: [Claims.AdminTenantsEdit],
        titleSuffix: "adminRoutes.titles.addTenantToUser",
        editing: true,
      },
      //#endregion Users
      //#region Execution Flows
      {
        path: PATHS.ADMIN_EXECUTION_FLOW_LANDING,
        component: <ExecutionFlowsGrid />,
        permissions: [Claims.AdminETLsView],
        titleSuffix: "etlRoutes.titles.executionFlows",
      },
      {
        path: PATHS.ADMIN_EXECUTION_FLOW_ADD,
        label: <Trans i18nKey="etlRoutes.addExecutionFlow" />,
        titleSuffix: "etlRoutes.titles.addExecutionFlow",
        component: <AddExecutionFlow />,
        permissions: [Claims.AdminETLsAdd],
        editing: true,
      },
      //#endregion Execution Flows
    ],
  },
];

export default ROUTES;
